<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">TODOS</option>
        <option v-for="TiposDocumento in TiposDeDocumentos" :key="TiposDocumento.IdTipo" :value="TiposDocumento.IdTipo">{{TiposDocumento.Descripcion}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposDeDocumentos: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoDocumentoEnvio", parametros);
    },
    methods: {
      cargaCatalogoDeTiposDeDocumentos() {  
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      

        axios.post(api.conexion + api.TemisCivil.catalogos.TiposDocumentoEnvio, this.parametros)      
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
                this.TiposDeDocumentos = respuesta.data.TiposDocumento;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoDocumentoEnvio", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoDeTiposDeDocumentos();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/TiposDocumentoEnvio.vue